export default __webpack_public_path__ + "static/media/openBook.01f68346.svg";